import { ROUTES } from '../config/appConfig';
import { normalizeUserRole } from './apiResponseUtils';

export const getRequiredVerificationRoute = (user) => {
  if (normalizeUserRole(user) === 'admin') return null;
  if (user?.emailVerificationRequired === true) return ROUTES.emailVerification;
  const googleAccount = [user?.provider, user?.authMethod].some(value => String(value).toUpperCase() === 'GOOGLE');
  if (user?.phoneVerificationRequired === true || (googleAccount && user?.phoneVerified !== true)) return ROUTES.phoneVerification;
  return null;
};

export const getVerificationDestination = (user, from) => {
  const isDriver = normalizeUserRole(user) === 'driver';
  const allowedPaths = isDriver ? [ROUTES.driverDashboard, ROUTES.driverWallet, '/driver/trips', '/driver/earnings', '/driver/ledger', '/driver/payouts', '/driver/support', '/driver/notifications'] : [
    ROUTES.dashboard, ROUTES.orders, ROUTES.checkout, ROUTES.paymentSuccess,
    '/dashboard/notifications', '/dashboard/support', ROUTES.bookVehicle, ROUTES.bookEstimate, '/dashboard/wallet', '/dashboard/account-closure', '/dashboard/account',
  ];
  return {
    to: (allowedPaths.includes(from?.pathname) || (!isDriver && /^\/dashboard\/(payments|checkout|booking-confirmed|support)\/[^/]+$/.test(from?.pathname || '')))
      ? from.pathname + (from.search || '')
      : isDriver ? ROUTES.driverDashboard : ROUTES.dashboard,
    state: from?.state || (isDriver ? null : { focusSection: 'create-delivery' }),
  };
};
